import { INBOX_USERS } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
export default RoutingRuleBase({
  '@type': INBOX_USERS
}, 'InboxUsersRoutingRules');